import React from 'react'
import PropTypes from 'prop-types'

import TableSplitButton from '~/components/TableSplitButton'
import useDeleteConfirm from '~/components/TableSplitButton/useDeleteConfirm'

function BulkActionButton ({ onTaxesDelete, loading }) {
  const { handleClick } = useDeleteConfirm()

  const options = [
    {
      label: 'Delete',
      'data-cy': 'deleteMenu',
      onMenuClick: () => handleClick(onTaxesDelete)
    },
  ]

  return (
    <TableSplitButton
      options={options}
      name="tax"
      loading={loading}
    />
  )
}

BulkActionButton.propTypes = {
  onTaxesDelete: PropTypes.func.isRequired,
  loading: PropTypes.bool
}

export default BulkActionButton
